<template>
  <pt-show-calculate-result class="pt-show-calculate-result__withData"></pt-show-calculate-result>
</template>

<script>
import PtShowCalculateResult from './index'
export default {
  name: 'pt-show-calculate-result__withData',
  components: {
    'pt-show-calculate-result': PtShowCalculateResult
  }
}
</script>
